import ServiceForm from "./Form";
import ServicesList from "./List";

export default function ServicesPage(props: any) {
  return (
    <div className="content_page">
      {(!props.action || props.action === "list") && <ServicesList />}

      {props.action && ["create", "edit"].includes(props.action) && (
        <ServiceForm action={props.action} />
      )}
    </div>
  );
}
